import React, { useMemo ,useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from './Axios/api';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Eye } from 'lucide-react';
import Loader from "./common/Loader";
import { useNavigate } from 'react-router-dom';
const QuotationHistory = () => {
  const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isloading, setIsLoading] = useState(false);
    const [month, setMonth] = useState("");
      const fetchData = async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`/purchase/get-quotation-comparison-list?type=history&month=${month}`);
              const sortedDesc = response.data.sort((a,b) => new Date(b.indent_date) - new Date (a.indent_date));
            //   console.log("api",response.data)
              setData(sortedDesc); 
              setIsLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [month])

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const monthNum = String(now.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${year}-${monthNum}`;
    setMonth(currentMonth);
  }, []);


    const columns = useMemo(
        () => [
            {
                accessorKey: 'indent_date',
                header: 'Date',
                size: '15%',
                Cell: ({ cell }) =>   new Intl.DateTimeFormat('en-GB').format(new Date(cell.getValue())),
            },
            {
                accessorKey: 'indent_number',
                header: 'Indent No.',
                size: '10%',
            },
            {
                accessorKey: 'po_number',
                header: 'Po No.',
                size: '10%',
            },
            {
                accessorKey: 'branch_name',
                header: 'Factory Name',
                size: '15%',
            },
            {
                accessorKey: 'indentItems',
                header: 'Item Titles',
                size: '30%',
                accessorFn: row => row.indentItems.map(item => item.item_title).join(', '), 
                Cell: ({ cell }) => (
                    <div className="max-h-10 overflow-y-auto">
                        {cell.getValue().split(', ').map((title, index) => (
                            <div key={index}>{title}</div>
                        ))}
                    </div>
                ),
            },
            {
                accessorKey: 'indent_remark',
                header: 'Remark',
                size: '10%',
            },
            {
                accessorKey: 'indent_by_name',
                header: 'Indent by name',
                size: '15%',
            },
            {
                accessorKey: '_id',
                header: 'Action',
                size: '5%',
                Cell: ({ cell, row }) => (
                    <Link
                        to={`/quote-comparison-detail/${row.original.unique_group_id}`}
                        className="m-2"
                    >
                        <button><Eye /></button>
                    </Link>
                ),
            },
        ],
        [month] 
    );

    const table = useMaterialReactTable({
        columns,
        data,month,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
    });

    return  (
         <div className="flex-1 px-5 w-full justify-center items-center">
               <div className="w-full flex flex-col md:flex-row md:items-center justify-between px-4 py-2 bg-[#fdfdfd] shadow rounded-md my-4 text-violet-500 font-bold">
                    <div className="text-lg mb-2 md:mb-0">
                        Quotation Comparison History
                    </div>
    
            <div className="mb-2 md:mb-0">
                <input
                    type="month" value={month}
                onChange={(e) => {
                  setMonth(e.target.value)}}
           
                    className="border rounded px-2 py-1 w-full md:w-auto"
                />        
            </div>

            <div
                onClick={() => navigate('/quote-comparison')}
                className="text-white font-bold rounded-md px-3 py-1 bg-violet-600 hover:bg-violet-700 shadow border flex items-center cursor-pointer transition-colors"
            >
                Back
            </div>
        </div>

            <div className='w-full min-h-[500px] rounded-md shadow bg-[#fdfdfd] '>
                {  isloading ? ( <Loader/>):(
               <MaterialReactTable table={table} />
               )}
            </div>
         </div>
    )
}

export default QuotationHistory;